import * as i0 from '@angular/core';
import { EventEmitter, HostListener, Output, Input, Component, NgModule } from '@angular/core';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i4 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

class DpListTreeHeaderComponent {
    constructor() {
        this.clickedAction = new EventEmitter();
        this.clickedItemAction = new EventEmitter();
        this.faEllipsisVertical = faEllipsisVertical;
        this.showMenu = false;
        this.dropId = this.generateUUID();
    }
    runAction(action) {
        this.clickedAction.emit(action);
    }
    runItemAction(item) {
        this.clickedItemAction.emit(item);
    }
    generateUUID() {
        return Date.now().toString(36).slice(2, 11) + Math.random().toString(36).slice(2, 7);
    }
    clickOptions() {
        this.showMenu = !this.showMenu;
        this.menuPosition();
    }
    onClickedOutside(target) {
        const clickedInsideComponent = document.getElementById(this.dropId)?.contains(target);
        if (!clickedInsideComponent) {
            this.showMenu = false;
        }
    }
    onResize() {
        this.menuPosition();
    }
    menuPosition() {
        if (this.showMenu) {
            const toggle = document.getElementById(this.dropId);
            let position;
            if (toggle) {
                position = toggle.getBoundingClientRect();
            }
            const menu = document.getElementById('menu-' + this.dropId);
            if (menu && position) {
                menu.style.transform = `translate(${position.left}px, ${position.top + 51}px)`;
            }
        }
    }
    checkMenuActions() {
        return this.rightAction?.dropdownMenu?.some(section => section.items.length > 0) ?? false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.3", type: DpListTreeHeaderComponent, selector: "dp-list-tree-header", inputs: { title: "title", leftActions: "leftActions", rightAction: "rightAction" }, outputs: { clickedAction: "clickedAction", clickedItemAction: "clickedItemAction" }, host: { listeners: { "document:click": "onClickedOutside($event.target)", "window:resize": "onResize($event)" } }, ngImport: i0, template: "<div class=\"dptree-header\">\n    <span class=\"dptree-header-text dpellipsis\" [ngbTooltip]=\"title.tooltip || '' | translate\" placement=\"right\">\n        {{ title.label | translate }}\n    </span>\n\n    @if (checkMenuActions()) {\n        <div\n            class=\"dptree-header-icon dropdown-toogle\"\n            [id]=\"dropId\"\n            data-bs-toggle=\"dropdown\"\n            aria-expanded=\"false\"\n            (click)=\"clickOptions()\"\n        >\n            <span class=\" \" [ngbTooltip]=\"rightAction.tooltip || '' | translate\" style=\"cursor: pointer\">\n                <fa-icon [icon]=\"faEllipsisVertical\" size=\"lg\"></fa-icon>\n            </span>\n        </div>\n        <div\n            [id]=\"'menu-' + dropId\"\n            class=\"dropdown-menu\"\n            [ngClass]=\"{ show: showMenu }\"\n            [attr.aria-labelledby]=\"dropId\"\n            style=\"position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(297px, 78px)\"\n            data-popper-placement=\"bottom-start\"\n        >\n            @for (section of rightAction.dropdownMenu; track $index) {\n                @if (section.items.length > 0) {\n                    @if (!$first) {\n                        <div class=\"dropdown-divider\"></div>\n                    }\n\n                    @if (section.label) {\n                        <li>\n                            <h6 [ngbTooltip]=\"section.tooltip || '' | translate\" class=\"dropdown-header\">\n                                {{ section.label | translate }}\n                            </h6>\n                        </li>\n                    }\n\n                    @for (item of section.items; track $index) {\n                        <a\n                            [ngbTooltip]=\"item.tooltip || '' | translate\"\n                            class=\"dropdown-item\"\n                            (click)=\"runItemAction(item)\"\n                        >\n                            {{ item.label | translate }}\n                        </a>\n                    }\n                }\n            }\n        </div>\n    }\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "animation", "mask", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "transform", "a11yRole"] }, { kind: "directive", type: i3.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "pipe", type: i4.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dp-list-tree-header', template: "<div class=\"dptree-header\">\n    <span class=\"dptree-header-text dpellipsis\" [ngbTooltip]=\"title.tooltip || '' | translate\" placement=\"right\">\n        {{ title.label | translate }}\n    </span>\n\n    @if (checkMenuActions()) {\n        <div\n            class=\"dptree-header-icon dropdown-toogle\"\n            [id]=\"dropId\"\n            data-bs-toggle=\"dropdown\"\n            aria-expanded=\"false\"\n            (click)=\"clickOptions()\"\n        >\n            <span class=\" \" [ngbTooltip]=\"rightAction.tooltip || '' | translate\" style=\"cursor: pointer\">\n                <fa-icon [icon]=\"faEllipsisVertical\" size=\"lg\"></fa-icon>\n            </span>\n        </div>\n        <div\n            [id]=\"'menu-' + dropId\"\n            class=\"dropdown-menu\"\n            [ngClass]=\"{ show: showMenu }\"\n            [attr.aria-labelledby]=\"dropId\"\n            style=\"position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(297px, 78px)\"\n            data-popper-placement=\"bottom-start\"\n        >\n            @for (section of rightAction.dropdownMenu; track $index) {\n                @if (section.items.length > 0) {\n                    @if (!$first) {\n                        <div class=\"dropdown-divider\"></div>\n                    }\n\n                    @if (section.label) {\n                        <li>\n                            <h6 [ngbTooltip]=\"section.tooltip || '' | translate\" class=\"dropdown-header\">\n                                {{ section.label | translate }}\n                            </h6>\n                        </li>\n                    }\n\n                    @for (item of section.items; track $index) {\n                        <a\n                            [ngbTooltip]=\"item.tooltip || '' | translate\"\n                            class=\"dropdown-item\"\n                            (click)=\"runItemAction(item)\"\n                        >\n                            {{ item.label | translate }}\n                        </a>\n                    }\n                }\n            }\n        </div>\n    }\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input
            }], leftActions: [{
                type: Input
            }], rightAction: [{
                type: Input
            }], clickedAction: [{
                type: Output
            }], clickedItemAction: [{
                type: Output
            }], onClickedOutside: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class DpListTreeHeaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderModule, declarations: [DpListTreeHeaderComponent], imports: [CommonModule,
            FontAwesomeModule,
            NgbModule,
            TranslateModule], exports: [DpListTreeHeaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderModule, imports: [CommonModule,
            FontAwesomeModule,
            NgbModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: DpListTreeHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DpListTreeHeaderComponent],
                    imports: [
                        CommonModule,
                        FontAwesomeModule,
                        NgbModule,
                        TranslateModule
                    ],
                    exports: [DpListTreeHeaderComponent]
                }]
        }] });

class HeaderAction {
    constructor(icon, tooltip, action, dropdownMenu, url) {
        this.icon = icon;
        this.tooltip = tooltip;
        this.action = action;
        this.dropdownMenu = dropdownMenu;
        this.url = url;
    }
    run() {
        if (this.action) {
            this.action.apply(this);
        }
    }
}

class DropdownSection {
    constructor(items, label, tooltip) {
        this.items = items;
        this.label = label;
        this.tooltip = tooltip;
    }
}

class DropdownItem {
    constructor(label, tooltip, action, url) {
        this.label = label;
        this.tooltip = tooltip;
        this.action = action;
        this.url = url;
    }
    run() {
        if (this.action) {
            this.action.apply(this);
        }
    }
}

class Icon {
    constructor(name, typeText, size, transform, cssClass, style) {
        this.name = name;
        this.typeText = typeText;
        this.size = size;
        this.transform = transform;
        this.cssClass = cssClass;
        this.style = style;
    }
}

class HeaderTitle {
    constructor(label, tooltip) {
        this.label = label;
        this.tooltip = tooltip;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { DpListTreeHeaderComponent, DpListTreeHeaderModule, DropdownItem as ListTreeDropdownItem, DropdownSection as ListTreeDropdownSection, HeaderAction as ListTreeHeaderAction, HeaderTitle as ListTreeHeaderTitle, Icon as ListTreeIcon };
